import React from "react";
import { formatTimestamp } from "./documentUtils";

// Wave 3 — delivery & receipt strip. Pure presentation over the state that
// deriveReceipt() computes in documentUtils.js.
const DeliveryReceipt = ({ receipt }) => {
  if (!receipt) return null;
  const { state, role, at, userName } = receipt;
  return (
    <section className="file-card__receipt" aria-label="Document delivery status">
      <div className={`file-card__receipt-state file-card__receipt-state--${String(state).toLowerCase()}`}>
        <span className="file-card__receipt-dot" aria-hidden="true" />
        <div>
          <span>Delivery &amp; receipt</span>
          <strong>{state}</strong>
        </div>
      </div>
      <div className="file-card__receipt-detail">
        <strong>{role}</strong>
        <span>
          {userName && state === "Opened" ? `${userName} · ` : ""}
          {formatTimestamp(at)}
        </span>
      </div>
    </section>
  );
};

export default DeliveryReceipt;
